import React, { useEffect, useRef, useState } from 'react';
import DatePicker from '@hassanmojab/react-modern-calendar-datepicker';
import '@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css';
import moment from "moment-jalali";
import { useEntityCrud } from '../../hooks/useEntityCrud';
import ReactSelect from 'react-select';
import { toast } from 'react-toastify';


const Index = () => {

    const { readData: getBusiness } = useEntityCrud('Business/GetAllBusiness');
    const { addData: addAnswerComment } = useEntityCrud('Answer/setReply');
    const { addData: updateComment } = useEntityCrud('Suggestion/changeSuggestionStatus');

    const { readData } = useEntityCrud('Report/getComments');
    const [filterItems, setFilterItems] = useState({});
    const [data, setData] = useState([]);

    const btnRef = useRef();
    const [issueDate, setIssueDate] = useState(null);
    const [expireDate, setExpireDate] = useState(null);

    const [issueDateRep, setIssueDateRep] = useState(null);
    const [expireDateRep, setExpireDateRep] = useState(null);

    const [advancedSearch, setAdvancedSearch] = useState(false);
    const [isLoading, setLoading] = useState(false);

    const [businesses, setBusinesses] = useState([]);
    const [business, setBusiness] = useState([]);
    const [showNotData, setShowNotData] = useState(false);

    const [comment, setComment] = useState('');
    const [commentAnswer, setCommentAnswer] = useState('');
    const [commentId, setCommentId] = useState('');
    const [commentStatus,setCommentStatus] = useState('10');
    const [answerStatus,setAnswerStatus] = useState('10');
    
    const [selectAll, setSelectAll] = useState(false);
    const [selectAllType,setSelectAllType] = useState('');
    const [selectAllStatus,setSelectAllStatus] = useState('');
    const [selected,setSelected] = useState([]);

    useEffect(() => {
        getData({}, filterItems);

        getBusiness().then(({ data }) => {
            let businesses = [];
            if (data.status)
                data.result.map(item => {
                    // if (item.isActive) {
                        if (!(businesses?.find(it => it.label === item.title))) {
                            businesses.push({
                                label: item.title,
                                value: item.id
                            });
                        }
                    // }
                })
            setBusinesses(businesses);
        });

    }, [])


    function convertToDate(date) {
        if (!date)
            return ""
        return moment(`${date.year}/${date.month}/${date.day}`, "jYYYY/jMM/jDD").format("jYYYYjMMjDD");
    }


    let localDataId = localStorage.getItem('user') != null ? JSON.parse(localStorage.getItem('user')) : {};
    let businessLocalTitle = localDataId?.lastName;
    let roleLocalId = localDataId?.roleId;
    let businessLocalId = localDataId?.businessId;


    const getData = (otherPostedData = {}, filteredPostedData = {}) => {
        const postedData = {
            "p_business": business ? business.toString() : (businessLocalId ? businessLocalId[0]?.toString() : 0),
            "p_cm_fromdate": convertToDate(issueDate) || convertToDate(getToday()),
            "p_cm_todate": convertToDate(expireDate) || convertToDate(getToday()),
            "p_rep_fromdate": convertToDate(issueDateRep)
        }
        if(commentStatus != 10)
            postedData.p_suggestionstatus = parseInt(commentStatus)
        if(answerStatus != 10)
            postedData.p_answerstatus = parseInt(answerStatus)
        setLoading(true)

        readData(postedData).then(({ data }) => {
            setLoading(false)
            btnRef.current.style.display = "block";
            // if (roleLocalId === 3) {
            //     if ((data.result.v_result.filter(item => item.business_title === businessLocalTitle)).length === 0) {
            //         setShowNotData(true)
            //     }
            //     else { setData(data.result.v_result.filter(item => item.business_title === businessLocalTitle)) }
            // } else {
            // }
            setData(data.result.v_result)


        });
    }


    const submitFilter = () => {
        btnRef.current.style.display = "none";
        getData({}, filterItems);
        setAdvancedSearch(true);
    }


    const saveAnswer = () => {
        const postedData = {
            "criticism": "",
            "suggestion": "",
            "answer": commentAnswer,
            "id": commentId
        };
        addAnswerComment(postedData).then(({ data }) => {
            if (data.status) {
                toast.success('   پاسخ با موفقیت ثبت شد');
                setCommentAnswer("")
                setComment("")

                getData();
            }
        })
    }

    const downloadExcel = () => {
        setLoading(true)
        const postedData = {
            p_business: business ? business.toString() : (businessLocalId ? businessLocalId[0]?.toString() : 0),
            p_cm_fromdate: convertToDate(issueDate) || convertToDate(getToday()),
            p_cm_todate: convertToDate(expireDate) || convertToDate(getToday()),
            p_rep_fromdate: convertToDate(issueDateRep),
            excelOutput: true
        }
        if(commentStatus != 10)
            postedData.p_suggestionstatus = parseInt(commentStatus)
        if(answerStatus != 10)
            postedData.p_answerstatus = parseInt(answerStatus)
        readData(postedData).then(({ data }) => {
            if(data.status)
                window.open(data.excelPath)
        }).finally(() => {
            setLoading(false)
        })
    }

    const removeFilter = () => {
        setFilterItems(oldData => ({}));
        setAdvancedSearch(false);
        setLoading(false);
        setData([]);
        setExpireDate(null)
        setIssueDate(null)
        setExpireDateRep(null)
        setIssueDateRep(null)
        setShowNotData(false)
        setBusiness([])
        setComment("")
    }


    function getToday() {
        const today = moment().format("jYYYY-jMM-jDD").split("-")
        return {
            year: +today[0],
            month: +today[1],
            day: +today[2]
        }
    }

    const confirmComment = (suggestionId,status,type) => {
        const postedData = {
            suggestionId: [suggestionId],
            answerStatus: type == 'comment' ? 2 : 1,
            status
        }
        updateComment(postedData).then((({data}) => {
            if(data.status){
                toast.success(`${type == 'comment' ? 'نظر' : 'پاسخ'} مورد نظر ${status ? 'تایید' : 'عدم تایید'} شد`);
                getData();
            }else
                toast.error('عملیات مورد نظر ناموفق بود');
        }))
    }

    const handleSelect = id => {
        const oldSelected = [...selected];
        if(oldSelected.includes(id)){
            const index = oldSelected.indexOf(id);
            oldSelected.splice(index,1);
        }else
            oldSelected.push(id);
        setSelected(oldSelected);
    }

    const handleSelectAll = status => {
        setSelectAll(status);
        if(status){
            const newData = [];
            data.map(item => {
                newData.push(item.id);
            })
            setSelected(newData);
        }else
            setSelected([])
    }

    useEffect(() => {
        if(selected.length){
            if(selected.length != data.length)
                setSelectAll(false);
            else
                setSelectAll(true);
        }
    },[selected])

    const groupUpdate = () => {
        const postedData = {
            suggestionId: selected,
            answerStatus: selectAllType == 'comment' ? 2 : 1,
            status: selectAllStatus == 1
        }
        updateComment(postedData).then((({data}) => {
            if(data.status){
                toast.success(`${selectAllType == 'comment' ? 'نظر' : 'پاسخ'} مورد نظر ${selectAllStatus == 1 ? 'تایید' : 'عدم تایید'} شد`);
                getData();
            }else
                toast.error('عملیات مورد نظر ناموفق بود');
        }))
    }

    const handleShowCommentMessage = index => {
        const comments = [...data]
        comments[index].showAll = comments[index].showAll == true ? false : true
        setData(comments)
    }

    return (
        <div className="card">
            <div className="card-header"><div className="card-title" >لیست نظرات  </div></div>
            <div className="card-body">

                <div className="row">
                    <div className="col-md-12">

                        <div className="mb-0 borderRightContact py-3 px-3">
                            <div className="panel panel-body  m-0 p-0 ">
                                <div className="row">
                                    <div className="col-md-4" style={{ position: "relative", zIndex: "10" }}>
                                        <div className="form-group">
                                            <label>کسب و کار</label>
                                            <ReactSelect
                                                noOptionsMessage={e => 'یافت نشد'}
                                                isDisabled={businesses.length === 1 ? true : false}
                                                placeholder="  همه موارد "
                                                options={businesses}
                                                value={businesses.length === 1 ? businesses[0] : businesses.filter(item => business.includes(item.value))}
                                                onChange={e => setBusiness([...e.map(i => i.value)])}
                                                isMulti={true}
                                            />


                                        </div>
                                    </div>
                                    <div className="col-md-2 p-0 deskTopShow" style={{ position: "relative", zIndex: "9" }}>
                                        <div className="form-group">
                                            <label htmlFor="issueDate"> از تاریخ (نظر)    </label><br />
                                            {issueDate && <i class="fe fe-x clear-select-btn" onClick={() => setIssueDate(null)} style={{left: 25}}></i>}
                                            <DatePicker
                                                name="p_fromdate"
                                                required
                                                locale="fa"
                                                shouldHighlightWeekends
                                                value={issueDate || getToday()}
                                                calendarPopperPosition={"bottom"}
                                                onChange={setIssueDate}
                                                className="form-control"
                                                inputPlaceholder=' تاریخ  را انتخاب کنید ...'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2 p-0" style={{ position: "relative", zIndex: "8" }}>
                                        <div className="form-group">
                                            <label htmlFor="p_todate"> تا تاریخ  (نظر)     </label><br />
                                            {expireDate && <i class="fe fe-x clear-select-btn" onClick={() => setExpireDate(null)} style={{left: 25}}></i>}
                                            <DatePicker
                                                name="p_todate"
                                                required
                                                locale="fa"
                                                shouldHighlightWeekends
                                                value={expireDate || getToday()}
                                                calendarPopperPosition={"bottom"}
                                                onChange={setExpireDate}
                                                className="form-control"
                                                inputPlaceholder='  تاریخ را انتخاب کنید ...'
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-2 deskTopShow" style={{ position: "relative", zIndex: "7", paddingLeft: "0" }}>
                                        <div className="form-group">
                                            <label htmlFor="issueDate"> از تاریخ (پاسخ)     </label><br />
                                            {issueDateRep && <i class="fe fe-x clear-select-btn" onClick={() => setIssueDateRep(null)} style={{left: 25}}></i>}
                                            <DatePicker
                                                name="p_fromdate"
                                                required
                                                locale="fa"
                                                shouldHighlightWeekends
                                                value={issueDateRep}
                                                calendarPopperPosition={"bottom"}
                                                onChange={setIssueDateRep}
                                                className="form-control"
                                                inputPlaceholder=' تاریخ  را انتخاب کنید ...'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2 p-0" style={{ position: "relative", zIndex: "6" }}>
                                        <div className="form-group">
                                            <label htmlFor="p_todate"> تا تاریخ  (پاسخ)   </label><br />
                                            {expireDateRep && <i class="fe fe-x clear-select-btn" onClick={() => setExpireDateRep(null)} style={{left: 25}}></i>}
                                            <DatePicker
                                                name="p_todate"
                                                required
                                                locale="fa"
                                                shouldHighlightWeekends
                                                calendarPopperPosition={"bottom"}
                                                value={expireDateRep}
                                                onChange={setExpireDateRep}
                                                className="form-control"
                                                inputPlaceholder='  تاریخ را انتخاب کنید ...'
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group" onChange={e => setCommentStatus(e.target.value)}>
                                            <label>وضعیت نظر</label>
                                            <select className="form-control">
                                                <option value="10">همه</option>
                                                <option value="1">تایید شده</option>
                                                <option value="0">رد شده</option>
                                                <option value="2">در انتظار بررسی</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group" onChange={e => setAnswerStatus(e.target.value)}>
                                            <label>وضعیت پاسخ</label>
                                            <select className="form-control">
                                                <option value="10">همه</option>
                                                <option value="1">تایید شده</option>
                                                <option value="0">رد شده</option>
                                                <option value="2">در انتظار بررسی</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-md-4" ref={btnRef} style={{marginTop: 30}}>
                                        <div className='d-flex'>
                                            <button className="btn btn-cyan px-4 "

                                                onClick={submitFilter}>
                                                <i class="fa fa-search mx-2"></i>
                                                جستجو
                                            </button>
                                            <button className="btn btn-success px-4 ms-2"

                                                onClick={downloadExcel}>
                                                <i class="fa fa-search mx-2"></i>
                                                دریافت خروجی اکسل
                                            </button>
                                            {advancedSearch &&
                                                <button className="btn btn-danger mx-2 px-4"
                                                    onClick={removeFilter}>
                                                    <i class="mdi mdi-filter-variant mx-1"></i>
                                                    حذف فیلتر
                                                </button>}
                                        </div>

                                    </div>

                                </div>


                            </div>
                        </div>

                        {isLoading ?
                            <div style={{ minHeight: "100px" }}>
                                <div className="lds-facebook my-4" >
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div >
                            </div>
                            :
                            <>

                                {comment ? <div className="col-12 borderR_  my-4">
                                    <h5 class="title current mt-1 d-flex justify-content-between ">
                                        <div>
                                            <i class="fa fa-hand-o-left"></i>
                                            <b>    ثبت پاسخ  </b>
                                            <br />
                                            <small class="text-danger ">
                                                <i class="fa fa-star mx-2"></i>
                                                با توجه به نظر مطرح شده پاسخ خود را ثبت کنید.
                                            </small>
                                        </div>
                                    </h5>

                                    <div className='row mx-auto' style={{ display: "flex", alignItems: "end" }}>

                                        <div className="col-md-12 pr-0">
                                            <div className="form-group">
                                                <div className="alert alert-info alert-dismissible">
                                                    <p className="mb-0 text-dark">{comment}</p>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12 pr-0">
                                            <div className="form-group">
                                                <textarea value={commentAnswer} name={"commentAnswer"} onChange={(e) => setCommentAnswer(e.target.value)} type="text"
                                                    className="form-control mt-0" />
                                            </div>
                                        </div>
                                        <div className="col-md-12 pb-3">
                                            <div className="form-group mb-0">
                                                <button className="btn btn-success px-4 btn-block"
                                                    onClick={() => saveAnswer()}
                                                >ذخیره پاسخ  </button>
                                            </div>
                                        </div>
                                    </div>
                                </div> : ''}
                                <hr />
                                {data?.length > 0 ? <div className=' mt-2' style={{ padding: "20px 5px", margin: "1% 3% !important" }}>
                                    <p className="mb-3 font-bold">عملیات گروهی</p>
                                    <div className="row mt-3 mb-5">
                                        <div className="col-md-2" style={{marginTop: 36}}>
                                            <div class="form-check form-check-inline px-2">
                                                <input class="form-check-input" type="checkbox" id="select-all" onChange={e => handleSelectAll(e.target.checked)} checked={selectAll} />
                                                <label class="form-check-label" for="select-all">انتخاب همه</label>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>نوع</label>
                                                <select className="form-control" onChange={e => setSelectAllType(e.target.value)}>
                                                    <option>انتخاب کنید</option>
                                                    <option value="comment">نظر</option>
                                                    <option value="answer">پاسخ</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>وضعیت</label>
                                                <select className="form-control" onChange={e => setSelectAllStatus(e.target.value)}>
                                                    <option>انتخاب کنید</option>
                                                    <option value="1">تایید</option>
                                                    <option value="0">عدم تایید</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2" style={{marginTop: 29}}>
                                            <button className="btn btn-success" onClick={groupUpdate}>به روزرسانی</button>
                                        </div>
                                    </div>

                                    <div className="row bg-white" style={{ borderRadius: 7 }}>
                                        {data?.map((call, index) => (
                                            <div className="col-md-6" key={'call-' + index}>
                                                <div className="card custom-border-1" style={{backgroundColor: call.suggestionstatus == 1 ? '#dbffdb' : '#fff'}}>
                                                    <div class="form-check form-check-inline px-2 mb-4">
                                                        <input class="form-check-input" type="checkbox" id={`select-${call.id}`} onChange={() => handleSelect(call.id)} checked={selected.includes(call.id)} />
                                                        <label class="form-check-label" for={`select-${call.id}`}>انتخاب</label>
                                                    </div>
                                                    {(roleLocalId == 1 || roleLocalId == 183) ? <p className='text-justify'> نام کسب و کار  : &nbsp;{call.business_title || '-'}</p> : ''}
                                                    {(roleLocalId == 1 || roleLocalId == 183) ? <p className='text-justify mb-1'>نام شخص : &nbsp;{call.full_name || '-'}</p> : ''}
                                                    {(roleLocalId == 1 || roleLocalId == 183) ? <hr /> : ''}
                                                    <p>
                                                        نظر: {call.showAll ? call.suggestion : (call.suggestion.toString().length < 60 ? call.suggestion : (call.suggestion.slice(0,60) + ' ...'))}
                                                        {call.suggestion.length > 60 && <p className="text-primary d-inline" style={{cursor: 'pointer'}} onClick={() => handleShowCommentMessage(index)}> ({call.showAll ? 'مشاهده کمتر' : 'مشاهده بیشتر'})</p>}
                                                    </p>
                                                    <p>تاریخ نظر: <span dir="ltr">{call.suggestion_date || '-'}</span></p>
                                                    {(roleLocalId == 1 || roleLocalId == 183) && !call.suggestionstatus ? (<p className="mb-1"><a onClick={() => confirmComment(call.id,true,'comment')} className="text-success me-3" role="button">تایید نظر</a> <a onClick={() => confirmComment(call.id,false,'comment')} className="text-danger" role="button">عدم تایید نظر</a></p>) : (roleLocalId == 3 && !call.answermsg ? <p><a onClick={() => {setComment(call.suggestion);setCommentAnswer(call.answermsg);setCommentId(call?.id)}} className="text-primary" role="button">پاسخ</a></p> : '')}
                                                    {call.answermsg ? <hr /> : ''}
                                                    {call.answermsg ? <p>پاسخ: {call.answermsg}</p> : ''}
                                                    {call.answermsg && call.answerdate ? <p>تاریخ پاسخ: <span dir="ltr">{call.answerdate || '-'}</span></p> : ''}
                                                    {(roleLocalId == 1 || roleLocalId == 183) && call.answermsg && !call.answerstatus ? <p><a onClick={() => confirmComment(call.id,true,'answer')} className="text-success me-3" role="button">تایید پاسخ</a> <a onClick={() => confirmComment(call.id,false,'answer')} className="text-danger" role="button">عدم تایید پاسخ</a></p> : ''}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                    :
                                    <>
                                        {showNotData && <div className='mb-4 alert alert-secondary'>
                                            <p>
                                                نظری ثبت نشده است!
                                            </p>
                                        </div>
                                        }
                                    </>
                                }
                            </>
                        }
                    </div >
                </div>
            </div>
        </div>
    )
}

export default Index;
